import React from 'react';

import { StyledHref, StyledUnorderedList } from './RefundPrivacyPage.style';

export const PRIVACY = [
    {
        title: 'Article 1. Definitions',
        paragraphs: [
            'For the purposes of this Refund and Compensation Policy, the following terms shall have the following meanings:',
            '1. Widgetter / application - software (application) that enables the User to optimize their workspace on a computer, including optimization of control elements and collection of basic information regarding the computer`s performance.',
            [
                '2. Website - the website ',
                <StyledHref key={1} href="https://widgetter.com/" target={'_blank'} rel="noreferrer">
                    https://widgetter.com/
                </StyledHref>,
                ' from which the User can download the Application. The term also includes all subdomains of the Website.',
            ],
            '3. Subscription - the scope of rights granted to the User for a fee or free of charge, depending on the functionality of the Application provided.',
            '4. User – a person using the Application.',
            '5. Device - a Mac personal computer (of any model) legally owned by the User.',
            '6. Rights Holder – Bitnite LLP, BIN: 220840009542.',
            '7. Payment Provider – a legal entity, Paddle LLC, authorized by the Rights Holder to accept payments from the User.',
        ],
    },

    {
        title: 'Article 2. User`s Right to Cancel Subscription',
        paragraphs: [
            'All refund requests from Users due to subscription cancellations are considered on a case-by-case basis.',
            'The Rights Holder has established that the User is entitled to a refund if notice of cancellation is submitted within 14 calendar days from the date of payment.',
            [
                'The User must send a refund request to: ',
                <StyledHref key={1} href="mailto:support@bitnite.studio" target={'_blank'} rel="noreferrer">
                    support@bitnite.studio
                </StyledHref>,
            ],
            'The Rights Holder is not responsible for the timeframe of the refund, as payments are processed by the Payment Provider.',
            'Upon receipt of the refund, the User must immediately stop using the Application. The Rights Holder has the right to independently suspend the User`s access to the Application within one day of receiving information about the refund from the Payment Provider.',
        ],
    },

    {
        title: 'Article 3. Non-Refundable Cases',
        paragraphs: [
            'The Rights Holder may deny a refund request in the following cases:',
            <StyledUnorderedList key={1}>
                <li>The Application was purchased for an incompatible platform.</li>
                <li>The User is unable to operate the Application in their computing environment.</li>
                <li>The Application cannot be used due to deficiencies of the User`s Device.</li>
            </StyledUnorderedList>,
            'The Rights Holder does not reimburse or credit the difference between the price paid by the User and a limited-time promotional price (e.g., during sales or special offers).',
        ],
    },

    {
        title: 'Contact details:',
        paragraphs: [
            'Bitnite, LLP.',
            'BIN: 220840009542',
            'The Republic of Kazakhstan. Almaty city, st. Zhandosova 1/1, (Business center "Success"), 2nd floor.',
        ],
    },
];